module.exports = __webpack_public_path__ + "static/media/review-2.37f945f3.png";